import { render, staticRenderFns } from "./NumInfo.vue?vue&type=template&id=5f4fcfd8&scoped=true"
import script from "./NumInfo.vue?vue&type=script&lang=js"
export * from "./NumInfo.vue?vue&type=script&lang=js"
import style0 from "./NumInfo.vue?vue&type=style&index=0&id=5f4fcfd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4fcfd8",
  null
  
)

export default component.exports